import { Avatar, Button, Dropdown, Image } from "antd";
import { useNavigate } from "react-router-dom";
import {
  ArrowDownIcon,
  ArrowLeft,
  TickIcon,
} from "../../../../atoms/CustomIcons";
import { CaretDownOutlined } from "@ant-design/icons";
import { useRef } from "react";
import { ProposalCompanyDataType } from "../../ducks/types";
import { changeProposalStatus } from "../../ducks/services";
import { useAppDispatch } from "../../../../config/hooks";
import { getProposalBuilderData } from "../../ducks/actions";
import { SuccessMessage } from "../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../atoms/Toasts/ErrorMessage";

interface HeaderProps {
  companyId: string;
  btnText1?: string;
  btnIcon1?: JSX.Element;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  proposalBuilderData: ProposalCompanyDataType | null;
  addProposal?: boolean;
  handleSubmitEstimate: () => void;
  proposalId: string;
  dealId: string;
}

export default function DocumentHeader({
  btnText1,
  btnIcon1,
  setLoading,
  proposalBuilderData,
  addProposal,
  dealId,
  proposalId,
  handleSubmitEstimate,
  companyId,
}: HeaderProps) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const dropdownRef = useRef<HTMLButtonElement>(null);

  const changeStatus = (val: string) => {
    setLoading(true);
    functionChangeStatus(val);
  };

  const functionChangeStatus = (val: string) => {
    const payload = {
      status: val,
    };
    console.log("payload", payload);
  };

  const handleStatusChange = (status: string) => {
    setLoading(true);
    handleSubmitEstimate();
    if (dealId) {
      const payload = {
        status,
        deal_id: dealId,
      };
      changeProposalStatus(payload, proposalId)
        .then(() => {
          setLoading(false);
          const payload = {
            proposal_id: proposalId,
          };
          dispatch(getProposalBuilderData(payload));
          SuccessMessage("Status changed");
          if (status === "approval_pending") {
            navigate(`/deals-detail/${dealId}/${companyId}`);
            // navigate(-1);
          }
        })
        .catch((e: unknown) => {
          if (e instanceof AxiosError) {
            setLoading(false);
            ErrorMessage(
              e?.response?.data?.error?.message ?? "Something went wrong"
            );
          } else {
            setLoading(false);
            ErrorMessage("Something went wrong");
          }
        });
    }
  };

  const statusItems = [
    {
      key: "inactive",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            changeStatus("inactive");
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#6C7478", borderRadius: "2px" }}
          />{" "}
          Inactive{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "onboarding",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            changeStatus("onboarding");
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#2098EE", borderRadius: "2px" }}
          />{" "}
          Onboarding{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "active",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            changeStatus("active");
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#00A07D", borderRadius: "2px" }}
          />{" "}
          Active{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "suspended",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            changeStatus("suspended");
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#F06400", borderRadius: "2px" }}
          />{" "}
          Suspended{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "archived",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            changeStatus("archived");
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#98A3A9", borderRadius: "2px" }}
          />{" "}
          Archived{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
  ];

  const sentProposalDocFunc = (id: string) => {
    navigate(`/send-proposal/${id}`);
    // setLoading(true);
    // const payload = {
    //   proposal_id: id ?? "",
    //   companyId: companyId,
    // };
    // sentProposalDoc(payload)
    //   .then(() => {
    //     setLoading(false);
    //     if (id) {
    //       const payload = {
    //         status: "sent",
    //         deal_id: dealId,
    //       };
    //       changeProposalStatus(payload, id)
    //         .then(() => {
    //           setLoading(false);
    //           const payload = {
    //             proposal_id: proposalId,
    //           };
    //           dispatch(getProposalBuilderData(payload));
    //           SuccessMessage("Proposal sent");
    //           navigate(`/deals-detail/${dealId}/${companyId}`);
    //         })
    //         .catch((e: unknown) => {
    //           if (e instanceof AxiosError) {
    //             setLoading(false);
    //             ErrorMessage(
    //               e?.response?.data?.error?.message ?? "Something went wrong"
    //             );
    //           } else {
    //             setLoading(false);
    //             ErrorMessage("Something went wrong");
    //           }
    //         });
    //     }
    //   })
    //   .catch((e: unknown) => {
    //     if (e instanceof AxiosError) {
    //       setLoading(false);
    //       ErrorMessage(
    //         e?.response?.data?.error?.message ?? "Something went wrong"
    //       );
    //     } else {
    //       setLoading(false);
    //       ErrorMessage("Something went wrong");
    //     }
    //   });
  };

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={
            <Image
              src="/images/potential-deals/email-icon.svg"
              preview={false}
            />
          }
          onClick={(e) => {
            e.stopPropagation();
            sentProposalDocFunc(proposalId);
          }}
        >
          <span style={{ textAlign: "left", marginTop: "-2px" }}>
            By email <br />
            <span
              style={{
                fontSize: "12px",
                color: "#6C7478",
                lineHeight: "16px",
                display: "block",
              }}
            >
              Send email directly from LandScaling.
            </span>
          </span>
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={
            <Image
              src="/images/potential-deals/link-icon.svg"
              preview={false}
            />
          }
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <span style={{ textAlign: "left", marginTop: "-2px" }}>
            Copy link <br />{" "}
            <span
              style={{
                fontSize: "12px",
                color: "#6C7478",
                lineHeight: "16px",
                display: "block",
              }}
            >
              Copy the link and send it through any <br />
              convenient method.
            </span>
          </span>
        </Button>
      ),
    },
  ];

  return (
    <div className="estimateHeader">
      <div className="headerLeft">
        <Button
          size="large"
          type="link"
          className="p-0 m-20 close_popup"
          onClick={() => navigate(`/deals-detail/${dealId}/${companyId}`)}
          icon={<ArrowLeft style={{ color: "#151718" }} />}
        />
        <div className="estimateHeaderText">
          <div className="estimateTitle">
            <div
              className="estimateTitleText"
              style={{ display: "flex", alignItems: "center", gap: "6px" }}
            >
              Potential Deal Name:
              <b>{proposalBuilderData?.proposal?.potential_deal?.name}</b>
            </div>
            {!addProposal && (
              <Dropdown
                menu={{
                  items: statusItems,
                  selectable: true,
                }}
                trigger={["click"]}
                overlayClassName="status_dropdown_overlay"
              >
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  className={`status_dropdown in_progress_status`}
                  ref={dropdownRef}
                >
                  {proposalBuilderData?.proposal?.status === "in_progress"
                    ? "In progress"
                    : proposalBuilderData?.proposal?.status ===
                      "approval_pending"
                    ? "Approval pending"
                    : proposalBuilderData?.proposal?.status}
                  <div className="icon_arrow">
                    <CaretDownOutlined />
                  </div>
                </Button>
              </Dropdown>
            )}
          </div>
          <div className="description">
            <Image src="/images/estimate/home-icon.svg" preview={false} />
            {proposalBuilderData?.proposal?.potential_deal?.property?.name ??
              ""}
          </div>
        </div>
      </div>
      <div className="two_btns">
        {btnText1 && (
          <Button htmlType="submit" size="large" className="btn-sm">
            {btnIcon1 && btnIcon1} {btnText1}
          </Button>
        )}
        <Button onClick={handleSubmitEstimate} className="white-btn">
          Save & close
        </Button>

        {proposalBuilderData?.proposal?.status === "in_progress" && (
          <Button
            htmlType="submit"
            size="large"
            className="mint-btn"
            onClick={() => handleStatusChange("approval_pending")}
          >
            Send for approval
          </Button>
        )}
        {proposalBuilderData?.proposal?.status === "approval_pending" && (
          <Button
            htmlType="submit"
            size="large"
            className="blue-btn"
            onClick={() => handleStatusChange("ready")}
          >
            Approve
          </Button>
        )}
        {proposalBuilderData?.proposal?.status === "ready" && (
          <Dropdown
            menu={{ items }}
            trigger={["click"]}
            placement="bottomRight"
            className="actionButton"
          >
            <Button htmlType="submit" size="large" className="light-blue-btn">
              Sent to customer{" "}
              <ArrowDownIcon
                style={{ color: "#fff", width: "10px", height: "10px" }}
              />
            </Button>
          </Dropdown>
        )}
        {/* {dealsDetailData?.status === "sent" && (
          <Button htmlType="submit" size="large" className="light-blue-btn">
            Follow up
          </Button>
        )} */}
      </div>
    </div>
  );
}
